// colori.ts — i colori primari tra cui scegliere (v021, al posto dei temi). Condiviso: app (temi/colori.ts) e server (PATCH /io).

export const COLORI_PRIMARI = [
  { id: "giallo", hex: "#FFD60A" },
  { id: "arancio", hex: "#FF9F1C" },
  { id: "corallo", hex: "#FF6B6B" },
  { id: "rosa", hex: "#FF5CC8" },
  { id: "lilla", hex: "#B79CFF" },
  { id: "azzurro", hex: "#5EB0FF" },
  { id: "ciano", hex: "#3DE0FF" },
  { id: "menta", hex: "#5CF2B0" },
  { id: "lime", hex: "#B6F23D" },
] as const;
export type IdColore = (typeof COLORI_PRIMARI)[number]["id"];
export const COLORE_PREDEFINITO: IdColore = "giallo";

export function eIdColore(x: unknown): x is IdColore {
  return typeof x === "string" && COLORI_PRIMARI.some((c) => c.id === x);
}
